import React, { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";
import StepWizard from "react-step-wizard";

import moment from "moment";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";

import AddContractTable from "../Contract/List/Add.js";

import ContractComponent from "../Contract/List/Component.js";

const AddContractModal = ({ branchId, nurseryId, bizApp, serviceAppList, appAuthTypeList, nurseryName, list, directorName, address, disabled = false }) => {
    const [show, setShow] = useState(false);
    const [bizAppMap, setBizAppMap] = useState(false);
    const [contractList, setContractList] = useState(false);

    useEffect(() => {
        return () => {};
    }, [branchId, nurseryId, bizApp, serviceAppList, appAuthTypeList, nurseryName, list, bizAppMap]);

    const initModal = (bizApp, list) => {
        if (bizApp && list) {
            const newBizAppMap = ContractComponent.func.getBizAppMap(bizApp, onChangeBizAppFold);
            list.sort((a, b) => {
                return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
            });
            list.forEach((s) => {
                if(s.unionId) {
                    let hasAllUnion = true;
                    const union = appAuthTypeList.all.find((at) => s.unionId == at.id);
                    if(union) {
                        union.subList.forEach((sa) => {
                            if(!hasAllUnion || !s.app_auth[sa.appId] || !(s.app_auth[sa.appId].approval == 'AP' || s.app_auth[sa.appId].approval == 'WT')) {
                                hasAllUnion = false;
                                s.app_auth[union.appId].authType = null;
                                s.app_auth[union.appId].authTypeName = null;
                            }
                        });
                    }
                    if(!hasAllUnion) {
                        s.unionId = null;
                        s.unionId_org = null;
                        s.unionSelected = null;
                    }
                }
            });
            setContractList(list);
            updateContractTotal(newBizAppMap, list);
        }
    };
    const updateContractTotal = (bizAppMap, list) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            Object.keys(bizAppMap).forEach((a) => {
                newBizAppMap[a].union = {};
                newBizAppMap[a].count = 0;
                newBizAppMap[a].count_org = 0;
                newBizAppMap[a].quantity = 0;
                newBizAppMap[a].quantity_org = 0;
            });
            list.forEach((c) => {
                if (c.is555) return;
                // 결합 상품 변동 정보
                if(c.unionId && c.unionId != c.unionId_org) {
                    const a = c.unionSelected.appId;
                    if(!newBizAppMap[a].union[c.unionId]) {
                        newBizAppMap[a].union[c.unionId] = {name: c.unionSelected.name, count: 0};
                    }
                    newBizAppMap[a].union[c.unionId].count++;
                }
                Object.keys(bizAppMap).forEach((a) => {
                    if (bizAppMap[a].info && c.app_auth[a]) {
                        if(c.app_auth[a].approval === "AP") {
                            newBizAppMap[a].count_org++;
                            newBizAppMap[a].quantity_org += Number(c[bizAppMap[a].info.quantity.field[0]]);
                        } else if ((!c.app_auth[a].approval_org || c.app_auth[a].approval_org == "NA") && c.app_auth[a].approval === "WT" && c[bizAppMap[a].info.quantity.field[0]]) {
                            newBizAppMap[a].count++;
                            newBizAppMap[a].quantity += Number(c[bizAppMap[a].info.quantity.field[0]]);
                        }
                    }
                });
            });
            setBizAppMap(newBizAppMap);
        }
    };
    const updateContractList = (list) => {
        setContractList(list);
        updateContractTotal(bizAppMap, list);
    };
    const onChangeBizAppFold = (app, bizApp, fold = undefined) => {
        let newBizAppMap = { ...bizApp };
        newBizAppMap[app].fold = fold == undefined ? !newBizAppMap[app].fold : fold;
        setBizAppMap(newBizAppMap);
    };
    if(!bizApp || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }
    return (
        <>
            <button
                className="btn btn-rounded btn-secondary btn-block"
                onClick={() => {
                    initModal(bizApp, list ? JSON.parse(JSON.stringify(list)) : list);
                    setShow(true);
                }}
                disabled={disabled}
            >
                <i className="fas fa-plus-circle mr-2" />
                계약 추가
            </button>
            <Modal
                id="modal-contract-add"
                className={`modal-contract modal-container fullscreen-modal`}
                show={show}
                onHide={() => {
                    if (window.confirm("계약 등록을 취소하시겠습니까?")) {
                        setShow(false);
                        // document.location.reload();
                    }
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-14">계약 추가</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="pt-1 pb-2">
                        <div className="row p-0 m-0 bg-primary-light">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <div className="page-header ml-2 mt-3 mb-3">
                                    <h3 className="">
                                        {nurseryName}
                                        <span className="text-muted">{` (${directorName || "-"}, ${address || "-"})`}</span>
                                    </h3>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" />
                        </div>
                        <div className="row m-0">
                            <div className="col">
                                <ContractStep
                                    bizApp={bizAppMap}
                                    serviceAppList={serviceAppList}
                                    appAuthTypeList={appAuthTypeList}
                                    setBizApp={setBizAppMap}
                                    nurseryName={nurseryName}
                                    list={contractList}
                                    setList={updateContractList}
                                    branchId={branchId}
                                    nurseryId={nurseryId}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ContractStep = ({ branchId, nurseryId, nurseryName, bizApp, serviceAppList, appAuthTypeList, list, setBizApp, setList }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList, appAuthTypeList, list]);
    const [currentStep, setCurrentStep] = useState(1);

    return (
        <StepWizard initialStep={currentStep} isLazyMount={true}>
            <Step1 list={list} bizApp={bizApp} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} setBizApp={setBizApp} setList={setList} nurseryName={nurseryName} nurseryId={nurseryId} branchId={branchId} />
            <Step2 list={list} bizApp={bizApp} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} setBizApp={setBizApp} setList={setList} nurseryName={nurseryName} nurseryId={nurseryId} branchId={branchId} />
            <Step3 list={list} bizApp={bizApp} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} setBizApp={setBizApp} setList={setList} nurseryName={nurseryName} nurseryId={nurseryId} branchId={branchId} />
        </StepWizard>
    );
};

const Step1 = (props) => {
    useEffect(() => {
        return () => {};
    }, [props.list, props.bizApp, props.serviceAppList, props.appAuthTypeList]);

    const addList = (age) => {
        const newList = [...props.list];
        let ageNum = 0;
        newList.forEach((c) => {
            if (age === c.age) ageNum++;
        });
        const newAuth = {
            id: 0,
            defaultAge: age,
            age: age,
            books_age: age,
            english_age: age,
            momo_age: age,
            dd_age: age,
            jelliing_age: age,
            device: null,
            quantity: 0,
            b_quantity: 0,
            e_quantity: 0,
            is_new: true,
            class_name: `${ContractComponent.func.ageStr(age)} ${ageNum + 1}반`,
            app_auth: {},
        };

        Object.keys(props.bizApp).forEach((b) => {
            newAuth.app_auth[b] = {
                approval: "NA",
                start_date: null,
                end_date: null,
                hasPreContractedBranch: props.bizApp[b].hasPreContractedBranch,
            };
        });

        newList.push(newAuth);

        props.setList(newList);
    };

    return (
        <>
            <div className="row mt-3 mb-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <span className="text-primary mr-2">[1/3]</span>
                    계약하고자 하는 연령의 [
                    <span className="bg-brand p-1 text-dark" style={{ borderRadius: "4px" }}>
                        반 <span className="fa fa-plus-circle bg-brand" />
                    </span>
                    ] 버튼을 눌러 계정을 생성하고 해당 반에서 이용하고자 하는 서비스를 체크한 후, [다음 단계] 버튼을 눌러 주시기 바랍니다.
                    <ul>
                        <li className="text-danger">각 반의 원아 수 정보를 반드시 입력해 주세요.</li>
                        <li className="text-danger">각 반의 디바이스 사용 정보를 반드시 입력해 주세요.</li>
                    </ul>
                </div>
            </div>

            <div className={`row`}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                    <span className="badge border p-2 m-2 text-12">
                        <button className="btn-brand ml-2 rounded" style={{ maxWidth: "90px" }} onClick={() => addList(0)}>
                            <span className="text-primary mr-2">만 2세반</span>
                            <span className="fa fa-plus-circle" />
                        </button>
                    </span>
                    <span className="badge border p-2 m-2 text-12">
                        <button className="btn-brand ml-2 rounded" style={{ maxWidth: "90px" }} onClick={() => addList(1)}>
                            <span className="text-primary mr-2">만 3세반</span>
                            <span className="fa fa-plus-circle" />
                        </button>
                    </span>
                    <span className="badge border p-2 m-2 text-12">
                        <button className="btn-brand ml-2 rounded" style={{ maxWidth: "90px" }} onClick={() => addList(2)}>
                            <span className="text-primary mr-2">만 4세반</span>
                            <span className="fa fa-plus-circle" />
                        </button>
                    </span>
                    <span className="badge border p-2 m-2 text-12">
                        <button className="btn-brand ml-2 rounded" style={{ maxWidth: "90px" }} onClick={() => addList(3)}>
                            <span className="text-primary mr-2">만 5세반</span>
                            <span className="fa fa-plus-circle" />
                        </button>
                    </span>
                    <span className="badge border p-2 m-2 text-12">
                        <button className="btn-brand ml-2 rounded" style={{ maxWidth: "90px" }} onClick={() => addList(123)}>
                            <span className="text-primary mr-2">혼합반</span>
                            <span className="fa fa-plus-circle" />
                        </button>
                    </span>
                </div>
            </div>

            <div className="div-table-contract">
                <div className={`row`}>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 m-0">
                        <AddContractTable.SelectTable
                            tableId={"createTable"}
                            bizApp={props.bizApp}
                            serviceAppList={props.serviceAppList}
                            appAuthTypeList={props.appAuthTypeList}
                            list={props.list}
                            setBizApp={props.setBizApp}
                            setList={props.setList}
                        />
                    </div>
                </div>
            </div>

            <div className="row m-3">
                <div className="col text-right">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            let addCount = 0;
                            let isValidate = true;
                            let isValidateDevice = true;
                            props.list.forEach((c) => {
                                const auth = c.app_auth;
                                props.serviceAppList.forEach((a) => {
                                    if(isValidate && a.contractUseTas && auth[a.key] && auth[a.key].approval === "WT") {
                                        if((!c[a.quantity.field[0] ]|| c[a.quantity.field[0]] <= 0)) {
                                            isValidate = false;
                                        } else {
                                            addCount++;
                                        }
                                    }
                                });
                                c.app_auth = auth;
                                if(!c.device) isValidateDevice = false;
                            });
                            if (!isValidate) {
                                alert("각 계약의 사용 원아 수를 입력해 주세요.");
                                return;
                            }
                            if (!isValidateDevice)  {
                                alert("이용할 디바이스를 선택해 주세요.");
                                return;
                            }
                            if (!addCount) {
                                alert("추가된 계약이 없습니다.");
                                return;
                            }

                            props.nextStep();
                        }}
                        disabled={!props.list || props.list.length === 0}
                    >
                        다음 단계
                        <i className="fas fa-arrow-alt-circle-right ml-3" />
                    </button>
                </div>
            </div>
        </>
    );
};

const Step2 = (props) => {
    useEffect(() => {
        return () => {};
    }, [props.list, props.bizApp, props.serviceAppList, props.appAuthTypeList]);

    return (
        <>
            <div className="row mt-3 mb-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <span className="text-primary mr-2">[2/3]</span>
                <span className="text-danger">체크한 서비스로 이용이 가능한 결합상품을 확인 및 선택 후 [다음 단계] 버튼을 눌러 주시기 바랍니다.</span>
                    <ul>
                        <li>반의 연령과 서비스의 수준이 일치하지 않는 경우, 드롭메뉴를 이용하여 수준을 변경해 주세요.</li>
                        <li>플라잉의 원아 수는 개별 입력해 주세요.</li>
                    </ul>
                </div>
            </div>

            <div className="div-table-contract">
                <div className={`row`}>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 m-0">
                        <AddContractTable.AddTable
                            tableId={"createTable"}
                            bizApp={props.bizApp}
                            serviceAppList={props.serviceAppList}
                            appAuthTypeList={props.appAuthTypeList}
                            list={props.list}
                            setBizApp={props.setBizApp}
                            setList={props.setList}
                        />
                    </div>
                </div>
            </div>

            <div className="row m-3">
                <div className="col">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            props.previousStep();
                        }}
                    >
                        <i className="fas fa-arrow-alt-circle-left mr-3" />
                        이전 단계
                    </button>
                </div>
                <div className="col text-right">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            let addCount = 0;
                            let isValidate = true;
                            let isValidateDevice = true;
                            props.list.forEach((c) => {
                                const auth = c.app_auth;
                                const bizApp = props.bizApp;
                                props.serviceAppList.forEach((a) => {
                                    if(isValidate && a.contractUseTas && auth[a.key] && auth[a.key].approval === "WT") {
                                        if((!c[a.quantity.field[0] ]|| c[a.quantity.field[0]] <= 0)) {
                                            isValidate = false;
                                        } else {
                                            addCount++;
                                        }
                                    }
                                })
                                c.app_auth = auth;
                                if(!c.device) isValidateDevice = false;
                            });
                            if (!isValidate) {
                                alert("각 계약의 사용 원아 수를 입력해 주세요.");
                                return;
                            }
                            if (!isValidateDevice)  {
                                alert("이용할 디바이스를 선택해 주세요.");
                                return;
                            }
                            if (!addCount) {
                                alert("추가된 계약이 없습니다.");
                                return;
                            }

                            props.nextStep();
                        }}
                        disabled={!props.list || props.list.length === 0}
                    >
                        다음 단계
                        <i className="fas fa-arrow-alt-circle-right ml-3" />
                    </button>
                </div>
            </div>
        </>
    );
};

const Step3 = (props) => {
    const [agreeTerm, setAgreeTerm] = useState(false);
    useEffect(() => {
        return () => {};
    }, [props.list, props.bizApp, props.serviceAppList, props.appAuthTypeList]);

    const submitContract = () => {
        let addCount = 0;
        let isValidate = true;
        let isValidateDevice = true;
        props.list.forEach((c) => {
            const auth = c.app_auth;
            props.serviceAppList.forEach((a) => {
                if(isValidate && a.contractUseTas && auth[a.key] && auth[a.key].approval === "WT") {
                    if((!c[a.quantity.field[0] ]|| c[a.quantity.field[0]] <= 0)) {
                        isValidate = false;
                    } else {
                        addCount++;
                    }
                }
            });
            c.app_auth = auth;
            if(!c.device) { isValidateDevice = false; }
        });
        if (!isValidate) {
            alert("각 반의 원아 수를 입력해 주세요.");
            return;
        }
        if (!isValidateDevice) {
            alert("이용할 디바이스를 선택해 주세요.");
            return;
        }
        if (!addCount) {
            alert("추가된 계약이 없습니다.");
            return;
        }
        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/contract/update/${props.branchId}/${props.nurseryId}`,
            data: {
                contracts: props.list,
            },
        })
            .then((res) => {
                if (res.data.code === 200) {
                    alert("계약 추가 요청 되었습니다.");
                    document.location.reload();
                } else if (res.data.code === 5001) {
                    const arr = res.data.exist_apps;
                    const names = [];
                    arr.forEach((a) => {
                        let name = "";
                        const sa = props.serviceAppList.find((sa) => sa.appId == a);
                        if(sa) {
                            name = sa.name;
                        }
                        if (name) names.push(name);
                    });

                    alert(`해당 원에는 이미 [${names.join(", ")}] 계약이 존재하여 계약을 등록 할 수 없습니다.`);
                    return;
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    return;
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
        /**/
    };

    let addedCount = 0;
    let addedTextUnion = '';
    let addedText = '';
    props.serviceAppList.forEach((a) => {
        if(a.contractUseTas && props.bizApp[a.key]) {
            Object.keys(props.bizApp[a.key].union).forEach((u) => {
                addedCount += props.bizApp[a.key].union[u].count;
                addedTextUnion += `${addedTextUnion ? ' / ' : ''} ${props.bizApp[a.key].info.name} ${props.bizApp[a.key].union[u].name} ${props.bizApp[a.key].union[u].count}건`;
            });
            if(props.bizApp[a.key].count > 0) {
                addedCount += props.bizApp[a.key].count;
                addedText += `${addedText ? ' / ' : ''} ${props.bizApp[a.key].info.name} ${props.bizApp[a.key].count}개`;
            }
        }
    });

    addedText = addedText +  (addedTextUnion ? '(' + addedTextUnion + ')' : '');

    return (
        <>
            <div className="row mt-3 mb-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <span className="text-primary mr-2">[3/3]</span>
                    각 상품별 계약 수량과 계약 기간을 확인하시고 수정할 내용이 없으면 약관 동의 체크 후, [계약 승인 요청] 버튼을 눌러 주시기 바랍니다.
                    <ul>
                        <li>계약 기간 변경이 필요한 경우, 종료 월을 변경해 주세요.</li>
                        <li>등록한 내용에 수정이 필요한 경우, ‘이전 단계’로 이동하여 수정해 주세요.​</li>
                    </ul>
                </div>
            </div>

            <div className="div-table-contract">
                <div className={`row`}>
                    <div className="col mb-3 m-0">
                        <AddContractTable.AddConfirmTable
                            tableId={"createTable"}
                            bizApp={props.bizApp}
                            serviceAppList={props.serviceAppList}
                            appAuthTypeList={props.appAuthTypeList}
                            list={props.list}
                            setBizApp={props.setBizApp}
                            setList={props.setList}
                        />
                    </div>
                </div>
            </div>
            <div className="row m-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-3 mb-2 border" style={{ borderRadius: "10px" }}>
                    <h5 className="text-danger mb-1">
                        <div className="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="agreeTerm"
                                name="agreeTerm"
                                checked={agreeTerm}
                                onChange={(e) => {
                                    setAgreeTerm(e.target.checked);
                                }}
                            />
                            <label className="custom-control-label text-danger" htmlFor="agreeTerm">
                                아래 약관을 정확히 확인하였고, 해당 내용에 동의합니다.
                            </label>
                        </div>
                    </h5>
                    <ol>
                        <li>
                            <span className="text-primary">{props.nurseryName}</span>에 공급하는{" "}
                            <strong>                                
                                <span className="text-primary mr-1">
                                    {addedText}
                                </span>                                
                            </strong>
                            프로그램 수량에 대한 이용료를 위 제시한 계약기간동안 지급한다.
                        </li>

                        <li>
                            사용 약정 기간이 완료되기 이전에 서비스 해지, 약정 철회 시 위약금을 “유엔젤“에 납입해야 한다.
                            <br/>
                            &lt;약정 잔여 개월 수(약정기간 - 납입 개월 수) X 월 이용금액을 위약금으로 부과&gt;
                        </li>
                        <li>그 밖의 사항은 유엔젤㈜와 체결한 영업계약서에 따른다.</li>
                    </ol>
                </div>
            </div>

            <div className="row m-3">
                <div className="col-9">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            props.previousStep();
                        }}
                    >
                        <i className="fas fa-arrow-alt-circle-left mr-3" />
                        이전 단계
                    </button>
                </div>
                <div className="col-3 text-right">
                    <button className="btn btn-secondary btn-rounded btn-block" disabled={!(addedCount > 0 && agreeTerm)} onClick={submitContract}>
                        <i className="fas fa-paper-plane mr-2" />
                        계약 승인 요청
                    </button>
                </div>
            </div>
        </>
    );
};

export default AddContractModal;
